import { Capacitor } from "@capacitor/core";
import { wireNativeNotificationActions } from "./nativePush";

/**
 * Native shell wiring for the Capacitor iOS/Android builds. No-ops on the
 * web so the same bundle runs everywhere. Kept lazy (dynamic imports) so the
 * web build never pulls native plugin code into the main chunk.
 */
export async function initNative() {
  if (!Capacitor.isNativePlatform()) return;
  const platform = Capacitor.getPlatform();

  // Status bar: dark text on the cloud background (Style.Light == dark content).
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Light });
    if (platform === "android") {
      await StatusBar.setBackgroundColor({ color: "#F7F8F9" });
      await StatusBar.setOverlaysWebView({ overlay: false });
    }
  } catch {
    /* plugin unavailable — ignore */
  }

  // Hide the native splash once the web view has booted.
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch {
    /* ignore */
  }

  // Android hardware back button: navigate back within the SPA, or exit at root.
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack || window.history.length > 1) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
  } catch {
    /* ignore */
  }

  // Provider data contains a validated internal route only. Register the
  // action listener once at shell startup so a native notification can open
  // the role-appropriate HoneyAcorn screen after the user taps it.
  await wireNativeNotificationActions();
}
